import { type BannersList } from '@cx-web/api-clients/banners-api/types';
import { trackEvent } from '@cx-web/utils/dataLayer';

import useMedia from '~/hooks/use-media';
import { getWebPImageUrlWithWidth } from '~/utils/getWebPImageUrlWithWidth';

import styles from '../styles/BannersCarousel.module.css';
import { events } from '../types';

function BannersCarouselGrid({ banners }: { banners: BannersList }) {
  const { isMobile } = useMedia();

  const imageWidth = isMobile ? 320 : 800;

  return (
    <ul className={styles.gridContainer}>
      {banners.map((banner, idx) => (
        <li className={styles.gridItem} key={idx}>
          <a
            href={banner.ctaUrl}
            onClick={() => {
              trackEvent(events.SPLASH_BANNER_CLICK, {
                eventAction: events.SPLASH_BANNER_CLICK,
                label: banner.style,
                bannerName: banner.bannerName,
                bannerType: banner.bannerType,
                bookieCode: banner.bookieCode,
                url: banner.ctaUrl,
                position: idx,
              });
            }}
            rel="noreferrer"
            target="_blank"
          >
            <div aria-label={banner.imageSmall.alt} className={styles.slide}>
              <img
                alt={banner.imageSmall.alt}
                className={styles.bannerImg}
                draggable={false}
                {...(idx === 0 ? { fetchpriority: 'high' } : { fetchpriority: 'low' })}
                src={getWebPImageUrlWithWidth(banner.imageSmall.url, imageWidth)}
              />
            </div>
          </a>
        </li>
      ))}
    </ul>
  );
}

export default BannersCarouselGrid;
